require('./brokerStorySummary.scss');
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
const classnames = require('classnames');
//@helpers
const TruncateText = require('components/commons/truncateText/truncateText');
const { OKLink } = require('commonsComponents/OKLink');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
// @ commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
//@constants
const {
    BROKER_PG_URL,
    BROKER_NEWS_TRUNCATE_LINES,
    BROKER_NEWS_TRUNCATE_CHAR_LIMIT,
    BROKER_NEWS_TRUNCATE_LINES_NEWS_VIEW
} = require('constants/index');

class StorySummary extends React.Component {
    render() {
        const { myDate, title, summary, readMore, colorTitle, newsSection, leftIcon, newIndex, pageName } = this.props;
        const shortenedTitle = (title.length > 70) ? `${ title.substring(0, 70) }...` : title;
        let pulseNewsHeightClassName = classnames('broker-story-summary', { 'broker-story-summary__pulse-news': !readMore });
        let linkClass = classnames('broker-story-summary__link', { 'broker-story-summary__link-in-general': !newsSection });

        let { myPath } = this.props;
        let objId = '';
        const icon = leftIcon ? <i className="icon icon-bookmark broker-story-summary__icon"></i> : '';

        if (colorTitle !== '') {
            objId = `broker-story-summary__title__${ colorTitle }`;
        } else {
            objId = `broker-story-summary__title`;
        }

        myPath = myPath || BROKER_PG_URL;

        let showReadMoreTextAndLink,
            linesLimit = BROKER_NEWS_TRUNCATE_LINES,
            summaryText;

        if (newsSection) {
            linesLimit = BROKER_NEWS_TRUNCATE_LINES_NEWS_VIEW;
        } else {
            pulseNewsHeightClassName = classnames('broker-story-summary__news-in-general');
        }

        const totalChars = linesLimit * BROKER_NEWS_TRUNCATE_CHAR_LIMIT;

        if (summary.length >= totalChars) {
            summaryText = (
                <TruncateText
                    str={summary}
                    charLimit={BROKER_NEWS_TRUNCATE_CHAR_LIMIT}
                    lineAmount={linesLimit}
                    lineFeed={false}
                    isHtml={true}
                />
           );
       } else {
           summaryText = (
               <HTMLSafeInjector
                   message={summary}
               />
           );
       }

        if (readMore) {
            const transformToOrdinal = {
                [0]: 'first',
                [1]: 'second',
                [2]: 'third',
                [3]: 'fourth',
                [4]: 'fifth'
            }
            showReadMoreTextAndLink = (
                <div>
                    <div className="broker-story-summary__summary">
                        {summaryText}
                    </div>
                    <div className={linkClass}>
                        <OKLink 
                            modifier="editorial" 
                            to={myPath} 
                            onClick={() => newIndex !== undefined && taggingEventHandled(pageName, 'newsCardNew', transformToOrdinal[newIndex])}
                        >
                            <FormattedText value="broker-summaryReadMore" />
                        </OKLink>
                    </div>
                </div>
            );
        }

        return (
            <article className={pulseNewsHeightClassName}>
                <div className="broker-story-summary__date">
                    {icon}{myDate}
                </div>

                <h2 className={objId}>
                    {shortenedTitle}
                </h2>

                {showReadMoreTextAndLink}
            </article>
        );
    }
}

StorySummary.defaultProps = {
    colorTitle: '',
    leftIcon: false,
    newIndex: 0
};

StorySummary.propTypes = {
    myDate: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    myPath: PropTypes.string,
    readMore: PropTypes.bool,
    colorTitle: PropTypes.string,
    newsSection: PropTypes.bool.isRequired,
    leftIcon:PropTypes.bool,
    newIndex: PropTypes.number,
    pageName: PropTypes.string
};

module.exports = StorySummary;
